import request from '@/axios'

export const getMultiLangList = (langTypeCd: string) => {
  return request.get({ url: `/v1/com001/getMultiLangList`, params: { langTypeCd } })
}
